import { Grid, Modal as ModalModule, Utils } from 'common';
import PropTypes from 'prop-types';
import React from 'react';
import DateCellRenderer from '../shared/DateCellRenderer.component';

const { GridPanel } = Grid;
const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { formatAddressToOneLine } = Utils.Util;

const usCurrencyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

const columnDefs = [
	{
		field: 'transactionDate',
		headerName: 'Print Date',
		width: 110,
		cellRenderer: 'DateCellRenderer',
	},
	{
		field: 'recipientAddress',
		headerName: 'Recipient',
		width: 200,
		// valueGetter (not cellRenderer): ag-Grid inserts strings returned from a
		// function cellRenderer as HTML, and the address is user-controlled text.
		valueGetter({
			data: {
				printDetails: { toAddress },
			},
		}) {
			return formatAddressToOneLine(toAddress, true);
		},
	},
	{
		field: 'refundType',
		headerName: 'Type',
		width: 120,
		valueGetter({ data: { printDetails } }) {
			return printDetails.refundTypeName;
		},
	},
	{
		field: 'amount',
		headerName: 'Cost',
		type: 'numericColumn',
		width: 80,
		cellClass: 'align-right',
		cellRenderer({ data: { totalAmount, printDetails } }) {
			const cost = totalAmount - printDetails.insuranceCost;
			return usCurrencyFormatter.format(cost);
		},
	},
	{
		field: 'ErrorDescription',
		headerName: 'Ineligible Reason',
		flex: 1,
		// valueGetter: downstream error text is untrusted and must not be parsed as HTML.
		valueGetter({
			data: { ErrorDescription, error, data: { statuses } = {} },
		}) {
			return (
				error?.errorMessage || ErrorDescription || statuses?.statusDescription
			);
		},
	},
];

const RefundSubmittedFailureModal = ({
	modalId,
	data: { isAllRequestedPrintsFailed, failedRequestedPrints },
}) => (
	<Modal
		modalId={modalId}
		className="history-refund refund-submitted-failure-modal"
		header="Refund"
		primaryButton={{
			text: 'Done',
			type: ModalButtonActionType.Ok,
		}}
	>
		<p>
			The following prints could not be submitted for a refund.{' '}
			{isAllRequestedPrintsFailed
				? ''
				: 'Any other prints were submitted successfully.'}
		</p>
		<GridPanel
			className="grid"
			columnDefs={columnDefs}
			defaultColDef={{
				suppressSizeToFit: true,
				suppressMovable: true,
				sortable: false,
				suppressMenu: true,
			}}
			domLayout="autoHeight"
			rowData={failedRequestedPrints}
			showPagination={false}
			frameworkComponents={{ DateCellRenderer }}
		/>
	</Modal>
);

RefundSubmittedFailureModal.propTypes = {
	data: PropTypes.shape({
		// prints that are failed to refund.
		failedRequestedPrints: PropTypes.array,

		// true if all the requested prints have failed to refund.
		isAllRequestedPrintsFailed: PropTypes.bool,
	}),
};

export default RefundSubmittedFailureModal;
